export default __webpack_public_path__ + "static/media/ReportIconPublic.c9348234.svg";